import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ReplaceSpecialCharToText } from "../../Helper/WidgetDataCommon";
import GenericGoogleSheetService from "../../Helper/GoogleSheetService";
import { layoutActions } from "../../store/layout-slice";
import Loader from "../UI/Loader";
import ButtonControl from "../UI/Buttons/ButtonControl";

const GSheetForm = ({ onCloseHandler, isEditGsheet, existingConnectionName }) => {
    const dispatch = useDispatch();
    const [workbooks, setWorkbooks] = useState([]);
    const [workbookSheets, setWorkbookSheets] = useState([]);
    const [selectedWorkbook, setSelectedWorkbook] = useState("");
    const [selectedSheet, setSelectedSheet] = useState("");
    const [connectionName, setConnectionName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [errorWorkbook, setErrorWorkbook] = useState("");
    const [errorSheet, setErrorSheet] = useState("");
    const [errorConnectionName, setErrorConnectionName] = useState("");
    const [responseMessage, setResponseMessage] = useState("");
    const sessionId = useSelector((state) => state.login.sessionId);
    const gAuthId = useSelector((state) => state.layout.googleAuthId);
    const [updatedConnectionDetails, setUpdatedConnectionDetails] = useState(null);
    const [gAuthIdForEdit, setGAuthIdForEdit] = useState(null);



    useEffect(() => {

        //fetch workbooks on load
        const fetchWorkbooks = async () => {
            try {
                setIsLoading(true);

                if (isEditGsheet) {
                    loadGoogleSheetDetails();
                } else {
                    if (gAuthId) {
                        await GenericGoogleSheetService.getWorkbookList(sessionId, gAuthId).then((res) => {
                            setWorkbooks(res);
                            setConnectionName(existingConnectionName);
                            setSelectedWorkbook("");
                            setSelectedSheet("");
                            setConnectionName("");
                            setWorkbookSheets([]);
                            setIsLoading(false);
                        }).catch((err) => {
                            setWorkbooks([]);
                            setIsLoading(false);
                            console.error(err);
                        });
                    }
                }

            } catch (error) {
                console.error("Error fetching workbooks:", error);
                setWorkbooks([]);
                setIsLoading(false);
            }
        };
        fetchWorkbooks();



    }, [isEditGsheet, existingConnectionName, gAuthId]);



    const loadGoogleSheetDetails = async () => {
        try {
            const connectionRes = await GenericGoogleSheetService.getGoogleSheetConnectionDetail(sessionId, existingConnectionName);
            const connectionDetail = JSON.parse(connectionRes);
            setUpdatedConnectionDetails(connectionDetail);
            setSelectedWorkbook(connectionDetail.workbookName);
            setSelectedSheet(connectionDetail.workSheetName);
            const _gAuthId = connectionDetail.gSheetUId;
            setGAuthIdForEdit(_gAuthId);
            await GenericGoogleSheetService.getWorkbookList(sessionId, _gAuthId).then((res) => {
                setWorkbooks(res);
                setConnectionName(existingConnectionName);

                GenericGoogleSheetService.getWorksheetList(sessionId, connectionDetail.workbookName, _gAuthId).then((res) => {
                    setWorkbookSheets(res);
                    setIsLoading(false);
                }).catch((err) => {
                    setWorkbookSheets([]);
                    setIsLoading(false);
                    console.error(err);
                });
            }).catch((err) => {
                setWorkbooks([]);
                setIsLoading(false);
                console.error(err);
            });

        } catch (error) {
            console.error('Error loading Google Sheet details:', error);
            setWorkbookSheets([]);
            setIsLoading(false);
        }
    };


    const onChangeGoogleSheetHandler = (event) => {
        const workbookName = event.target.value;
        setSelectedWorkbook(workbookName);
        setWorkbookSheets([]);

        if (workbookName === "") {
            return;
        }

        const _gAuthId = isEditGsheet ? gAuthIdForEdit : gAuthId;
        try {
            GenericGoogleSheetService.getWorksheetList(sessionId, workbookName, _gAuthId).then((res) => {
                setWorkbookSheets(res);
            }).catch((err) => {
                console.error(err);
                setWorkbookSheets([]);
            });
        } catch (error) {
            console.error("Error fetching worksheets:", error);
            setWorkbookSheets([]);
        }
    };

    const onChangeWorkSheetHandler = (event) => {
        const sheetName = event.target.value;
        setSelectedSheet(sheetName);
    };

    const onChangeConnectionNameHandler = (event) => {
        const connectionName = event.target.value;
        setConnectionName(connectionName);
    };

    const OnSaveHandler = () => {
        const isValid = validateDataForm();
        if (!isValid) {
            return;
        }

        try {
            setIsLoading(true);
            GenericGoogleSheetService.saveGoogleConnection(sessionId, selectedWorkbook, connectionName, selectedSheet, gAuthId).then((res) => {
                if (res.indexOf('connection name already exists') >= 0) {
                    setIsLoading(false);
                    setResponseMessage(res);
                    setTimeout(() => { setResponseMessage("") }, 5000);
                    return;
                }
                const connName = ReplaceSpecialCharToText(connectionName);
                dispatch(layoutActions.setAddUpdateGsheetObj(connName));
                dispatch(layoutActions.setGsheetPopup(false));
            }).catch((err) => {
                console.error(err);
            });
        } catch (error) {
            console.error("Error saving Google Sheet connection:", error);
            setIsLoading(false);
        }
    };




    const onUpdateHandler = () => {

        const isValid = validateDataForm();
        if (!isValid) {
            setIsLoading(false);
            return;
        }

        try {
            const updatedDetails = updatedConnectionDetails;
            updatedDetails.connectionName = connectionName;
            updatedDetails.workbookName = selectedWorkbook;
            updatedDetails.workSheetName = selectedSheet;
            setIsLoading(true);

            GenericGoogleSheetService.updateGoogleConnection(sessionId, updatedDetails).then((res) => {
                if (res.indexOf('connection name already exists') >= 0) {
                    setIsLoading(false);
                    setResponseMessage(res);
                    setTimeout(() => { setResponseMessage("") }, 5000);
                    return;
                }
                const connName = ReplaceSpecialCharToText(connectionName);
                dispatch(layoutActions.setAddUpdateGsheetObj(connName));
                dispatch(layoutActions.setGsheetPopup(false));
            }).catch((err) => {
                console.error(err);
            });
        } catch (error) {
            console.error("Error updating Google Sheet connection:", error);
            setIsLoading(false);
        }

    };


    function validateDataForm() {
        if (selectedWorkbook === "") {
            setErrorWorkbook("Required");
            setTimeout(() => { setErrorWorkbook("") }, 5000);
            return false;
        }
        if (selectedSheet === "") {
            setErrorSheet("Required");
            setTimeout(() => { setErrorSheet("") }, 5000);
            return false;
        }

        if (connectionName.trim() === "") {
            setErrorConnectionName("Required");
            setTimeout(() => { setErrorConnectionName("") }, 5000);
            return false;
        }

        const regex = /^[A-Za-z0-9 ]+$/;
        const isValid = regex.test(connectionName);
        if (!isValid) {
            setErrorConnectionName("Special character not allowed!");
            setTimeout(() => { setErrorConnectionName("") }, 5000);
            return false;
        }

        return true;
    }

    const onDeleteHandler = () => {
        if (!existingConnectionName) {
            return;
        }

        try {
            const result = window.confirm("Are you sure you want to delete connection?");
            if (result) {
                setIsLoading(true);
                GenericGoogleSheetService.deleteGoogleSheetConnection(sessionId, existingConnectionName).then((res) => {
                    dispatch(layoutActions.setIsDeletedGsheet(true));
                    dispatch(layoutActions.setGsheetPopup(false));
                    setIsLoading(false);
                }).catch((err) => {
                    console.error(err);
                });
            }
        } catch (error) {

        }
    };

    return (
        <>
            {!isLoading && (<form id="widget-settings-form" className="settings">
                <div>
                    <p>Google Sheet</p>
                    <select
                        onChange={onChangeGoogleSheetHandler}
                        value={selectedWorkbook}
                    >
                        <option value="">Select Google Sheet</option>
                        {Array.isArray(workbooks) && workbooks.map((item, index) => {
                            return (<option key={index} value={item.sheetName}>
                                {item.sheetName}
                            </option>);
                        })}
                    </select>
                    <span
                        style={{
                            display: errorWorkbook.length > 0 ? "block" : "none",
                            color: "red",
                            paddingLeft: "5px",
                        }}
                    >
                        Required
                    </span>
                    <p>Table</p>
                    <select
                        onChange={onChangeWorkSheetHandler}
                        value={selectedSheet}
                    >
                        <option value="">Select Table</option>
                        {Array.isArray(workbookSheets) && workbookSheets.map((sheet, index) => (
                            <option key={index} value={sheet}>
                                {sheet}
                            </option>
                        ))}
                    </select>
                    <span
                        style={{
                            display: errorSheet.length > 0 ? "block" : "none",
                            color: "red",
                            paddingLeft: "5px",
                        }}
                    >
                        Required
                    </span>

                    <p>Connection Name</p>
                    <input type="text" value={connectionName} onChange={onChangeConnectionNameHandler} />
                    <span
                        style={{
                            display: errorConnectionName.length > 0 ? "block" : "none",
                            color: "red",
                            paddingLeft: "5px",
                        }}
                    >
                        {errorConnectionName}
                    </span>
                </div>
                <span style={{
                    display: responseMessage.length > 0 ? "block" : "none",
                    color: "red",
                    paddingLeft: "5px",
                }}>{responseMessage}</span>
                <br></br>
                <div id="settings-buttons">
                    {isEditGsheet === false && <ButtonControl cssStyle={{ marginRight: "3px" }} onClick={OnSaveHandler} text={"Save"} />}
                    {isEditGsheet === true &&
                        (<>
                            <ButtonControl cssStyle={{ marginRight: "3px" }} onClick={onUpdateHandler} text={"Update"} />
                            <ButtonControl cssStyle={{ marginRight: "3px" }} onClick={onDeleteHandler} text={"Delete"} />
                        </>)}
                    <ButtonControl
                        title="Close"
                        text="Close"
                        onClick={onCloseHandler}
                    />
                </div>
            </form>)}
            {isLoading && (<div style={{ paddingTop: '30px', paddingBottom: "30px" }}><Loader styles={{ height: "80px" }} /></div>)}
        </>
    );
};

export default GSheetForm;
